import React from 'react';
import styled from 'styled-components';

const EventListStyle = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  padding-left: 0;
`;

export const EventShortList = ({ list, count = 6 }) => {
  const isBoost = window.ASC_IS_BOOST;

  const dateSort = (a, b) => {
    if (a.startTime < b.startTime) {
      return -1;
    } else if (a.startTime > b.startTime) {
      return 1;
    }
    return 0;
  };

  const isFeatured = (cats) => {
    return cats.some((cat) => cat.slug === 'featured');
  };

  const sortFeatured = (a, b) => {
    if (isFeatured(a.categories) && !isFeatured(b.categories)) {
      return -1;
    }
    return 0;
  };

  const filterBySite = ({ hideOnJoy, hideOnBoost }) => {
    if (isBoost) {
      return !hideOnBoost;
    } else {
      return !hideOnJoy;
    }
  };

  const formatDates = (start, end) => {
    const sDate = new Date(start);
    const eDate = end ? new Date(end) : sDate;

    const MONTHS = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    if (sDate.getMonth() === eDate.getMonth()) {
      if (sDate.getDate() === eDate.getDate()) {
        return (
          <>
            <span className='month'>{MONTHS[sDate.getMonth()]}</span>
            <span className='spacer'> </span>
            <span className='day'>{sDate.getDate()}</span>
          </>
        );
      } else {
        return (
          <>
            <span className='month'>{MONTHS[sDate.getMonth()]}</span>
            <span className='spacer'> </span>
            <span className='day'>{sDate.getDate()}</span>
            <span className='dash'>-</span>
            <span className='day'>{eDate.getDate()}</span>
          </>
        );
      }
    } else {
      return (
        <>
          <span className='month'>{MONTHS[sDate.getMonth()]}</span>
          <span className='spacer'> </span>
          <span className='day'>{sDate.getDate()}</span>
          <span className='dash'>-</span>
          <span className='month'>{MONTHS[eDate.getMonth()]}</span>
          <span className='day'>{eDate.getDate()}</span>
        </>
      );
    }
  };

  return (
    <div>
      <EventListStyle className={`event-list-${list.id.toLowerCase()}`}>
        {list.events
          .filter(filterBySite)
          .sort(dateSort)
          .sort(sortFeatured)
          .slice(0, count)
          .map(
            ({
              title,
              startTime,
              endTime,
              description,
              signupLink,
              eventLink,
              imageUrl,
              address,
              categories,
            }) => (
              <React.Fragment key={title}>
                {isBoost ? (
                  <a
                    href={eventLink}
                    className={`block list-item ${
                      imageUrl ? 'image-event-link ' : ''
                    }${isFeatured(categories) ? 'featured ' : ''}event-link`}
                  >
                    {imageUrl && (
                      <img
                        src={imageUrl[0]}
                        alt={`${title}`}
                        className='event-image'
                      />
                    )}
                    <div className='info'>
                      <span className='title'>{title}</span>
                      <div className='event-info'>
                        <span className='start-date'>
                          {formatDates(startTime, endTime)}
                        </span>
                        {address && (
                          <div
                            className='address'
                            dangerouslySetInnerHTML={{ __html: address }}
                          />
                        )}
                      </div>
                      {/* <div className='description'>{description}</div>
                      <a href={signupLink || eventLink} class='link'>
                        Details
                      </a> */}
                    </div>
                  </a>
                ) : (
                  <div
                    className={`block list-item ${
                      imageUrl ? 'image-event-link ' : ''
                    }${isFeatured(categories) ? 'featured ' : ''}event-link`}
                  >
                    {imageUrl && (
                      <img
                        src={imageUrl[0]}
                        alt={`${title}`}
                        className='event-image'
                      />
                    )}
                    <div className='info'>
                      <span className='start-date'>
                        {formatDates(startTime, endTime)}
                      </span>
                      <span className='title'>{title}</span>
                      <div
                        className='description'
                        dangerouslySetInnerHTML={{ __html: description }}
                      />
                      <a href={eventLink} className='link'>
                        Details
                      </a>
                    </div>
                  </div>
                )}
              </React.Fragment>
            )
          )}
      </EventListStyle>
    </div>
  );
};
